import {
  Dialog, DialogActions, DialogContent, Slide,
} from '@material-ui/core';
import { ErrorOutline as ErrorOutlineIcon } from '@material-ui/icons';
import { prop } from 'ramda';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions } from '#store';
import Button from '#components/CustomButtons/Button';
import { MODAL_BUTTON_VARIANTS } from './constants';
import { useModalStyles } from './styles';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="down" ref={ref} {...props} />
));

const Modal = () => {
  const classes = useModalStyles();
  const dispatch = useDispatch();
  const modal = useSelector(prop('modal'));
  const properClose = useCallback(() => dispatch(actions.modal.close.creator()), [dispatch]);

  const {
    isOpen,
    buttonRight = null,
    buttonLeft = {
      variant: MODAL_BUTTON_VARIANTS.ko,
      text   : 'Close',
      onClick: () => {
        properClose();
        if (modal.onClose) {
          modal.onClose();
        }
      },
    },
    icon = <ErrorOutlineIcon className={classes.iconAlert} />,
    content,
  } = modal;

  return isOpen ? (
    <Dialog
      BackdropProps={{
        'data-testid': 'confirm-modal-backdrop',
      }}
      data-testid="confirm-modal"
      classes={{
        paper: classes.paper,
      }}
      open={isOpen}
      transition={Transition}
      keepMounted
      onClose={properClose}
      aria-labelledby="modal-slide-title"
      aria-describedby="modal-slide-description"
    >
      <DialogContent className={classes.content}>
        {icon}
        {content}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          data-testid="modal-btn-left"
          className={classes[`button-${buttonLeft.variant}`]}
          onClick={buttonLeft.onClick}
        >
          {buttonLeft.text}
        </Button>
        {buttonRight && (
          <Button
            data-testid="modal-btn-right"
            className={classes[`button-${buttonRight.variant}`]}
            onClick={buttonRight.onClick}
          >
            {buttonRight.text}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  ) : null;
};

export default Modal;
